import { BN } from '@coral-xyz/anchor';

export const uiAmountToLamports = (amount: number | string, decimals: number): BN => {
  try {
    const amountString = typeof amount === 'string' ? amount : amount.toString();
    // Basic validation
    if (!/^[0-9]+(\.[0-9]*)?$/.test(amountString) || amountString.startsWith('.') || amountString.endsWith('.')) {
      return new BN(0);
    }
    const parts = amountString.split('.');
    const integerPart = parts[0] || '0';
    // Pad fractional part correctly
    const fractionalPart = (parts[1] || '').padEnd(decimals, '0').slice(0, decimals);
    const lamportsString = integerPart + fractionalPart;
    // Final validation
    if (!/^[0-9]+$/.test(lamportsString) || lamportsString.length === 0) {
        console.warn(`Non-numeric or empty lamport string generated: ${lamportsString} from UI amount ${amountString}`);
        return new BN(0);
    }
    return new BN(lamportsString);
  } catch (error) {
    console.error("Error converting UI amount to lamports:", error, { amount, decimals });
    return new BN(0);
  }
};

export const lamportsToSol = (lamports: BN | number | bigint | undefined, decimals: number): number => {
  if (lamports === undefined) return 0;
  try {
    const bnLamports = new BN(lamports);
    // Ensure non-negative
    if (bnLamports.isNeg()) {
      return 0;
    }
    const divisor = new BN(10).pow(new BN(decimals));
    // Ensure divisor is positive
    if (divisor.isZero() || divisor.isNeg()) {
        console.error("Invalid divisor for lamportsToSol:", { divisor: divisor.toString(), decimals });
        return 0;
    }
    const { div, mod } = bnLamports.divmod(divisor);
    // Ensure fractional part is non-negative before padding
    const modString = mod.isNeg() ? mod.neg().toString() : mod.toString();
    // Ensure result is a number
    const result = parseFloat(`${div.toString()}.${modString.padStart(decimals, '0')}`);
    return isNaN(result) ? 0 : result;
  } catch (error) {
    console.error("Error converting lamports to SOL:", error, { lamports, decimals });
    return 0;
  }
};
